import React from "react";
import PropTypes from "prop-types";
import AdminRoute from "./AdminRoute";
import OrganizationsPage from "../components/admin/organizations/OrganizationsPage";
import AdminNewOrganizationPage from "../components/admin/organizations/NewOrganizationPage";
import AdminEditOrganizationPage from "../components/admin/organizations/EditOrganizationPage";
import SuperAdminsPage from "../components/admin/super-admins/SuperAdminsPage";
import NewSuperAdminPage from "../components/admin/super-admins/NewSuperAdminPage";
import EditSuperAdminPage from "../components/admin/super-admins/EditSuperAdminPage";
import UploadsPage from "../components/admin/uploads/UploadsPage";
import AuditLogsPage from "../components/admin/audit-logs/AuditLogsPage";
import ProfilePage from "../components/admin/profile/ProfilePage";
import TicketsPage from "../components/admin/support/TicketsPage";
import TicketPage from "../components/admin/support/TicketPage";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import AdminLoginPage from "../components/admin/login/LoginPage";
import PageNotFound from "../components/PageNotFound";
import InvitesPage from "../components/admin/invites/InvitesPage";

const AdminRoutes = ({ cableApp }) => (
  <Router>
    <Switch>
      <PublicRoute component={AdminLoginPage} exact path="/login" />
      <AdminRoute
        cableApp={cableApp}
        component={OrganizationsPage}
        exact
        path="/"
      />
      <AdminRoute
        cableApp={cableApp}
        component={AdminNewOrganizationPage}
        exact
        path="/organizations/new"
      />
      <AdminRoute
        cableApp={cableApp}
        component={AdminEditOrganizationPage}
        exact
        path="/organizations/:id/edit"
      />
      <AdminRoute
        cableApp={cableApp}
        component={SuperAdminsPage}
        exact
        path="/super-admins"
      />
      <AdminRoute
        cableApp={cableApp}
        component={NewSuperAdminPage}
        exact
        path="/super-admins/new"
      />
      <AdminRoute
        cableApp={cableApp}
        component={EditSuperAdminPage}
        exact
        path="/super-admins/:id/edit"
      />
      <AdminRoute
        cableApp={cableApp}
        component={UploadsPage}
        exact
        path="/uploads"
      />
      <AdminRoute
        cableApp={cableApp}
        component={AuditLogsPage}
        exact
        path="/audit-logs"
      />
      <AdminRoute
        cableApp={cableApp}
        component={ProfilePage}
        exact
        path="/profile"
      />
      <AdminRoute
        cableApp={cableApp}
        component={TicketsPage}
        exact
        path="/tickets"
      />
      <AdminRoute
        cableApp={cableApp}
        component={TicketPage}
        exact
        path="/ticket"
      />
      <AdminRoute
        cableApp={cableApp}
        component={InvitesPage}
        exact
        path="/organizations/:id/invites"
      />
      <Route component={PageNotFound} />
    </Switch>
  </Router>
);

AdminRoutes.propTypes = {
  cableApp: PropTypes.object.isRequired,
};

export default AdminRoutes;
